const a = {
  padding: "8px 14px"
};
export {
  a as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/tooltip/styles/_common.js
// module id = 1712
// module chunks = 41